import * as types from "../types/permission.types";

const initialState = {
  permissions: [
    {name:"permission_not_loded"},
  ],
};

const PermissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PERMISSIOM_DATA:
      return { ...state, permissions: action.payload };
    case types.RESET_PERMISSION_REDUCER:
      return {
        ...state,
        permissions: initialState.permissions,
      };
    default:
      return state;
  }
};
export default PermissionReducer;
